module.exports = __webpack_public_path__ + "static/media/home-icon-soul.a55855ca.svg";